// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"464":"5e800464","787":"2cdc5a1b"}[chunkId] + ".chunk.js";
};